import { render } from "./CardList.vue?vue&type=template&id=47e6f1c5&scoped=true"
import script from "./CardList.vue?vue&type=script&lang=js"
export * from "./CardList.vue?vue&type=script&lang=js"

import "./CardList.vue?vue&type=style&index=0&id=47e6f1c5&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e6f1c5"]])

export default __exports__